import { FC, useState } from "react"
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import { MdEdit, MdOutlineCancel } from "react-icons/md";
import { InputText } from "primereact/inputtext";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import { Dropdown } from "primereact/dropdown";

export const EditHerbaceoModalDialog:FC<any> = (props):JSX.Element => {

    const { dataTable, setData, comentarioEnEdicion, dataTableMASTER, visible, selectedCell, selectedRow, setSelectedRow, handleClose, type, setChangesFlag, fullData } = props 

    const [comment, setComment] = useState<string>(selectedRow?.[selectedCell])


    const handleUpdateDataHerbaceo = () => {
        if(type === 'Ext') {
            let original = dataTableMASTER.find((ori:any) => `${ori.id_provider}${ori.id_warehouse}` === `${selectedRow.id_provider}${selectedRow.id_warehouse}`)?.[selectedCell]
            let aux = dataTable
    
            let herbaceo_table = aux.map((a:any) => {
                if(`${a.id_provider}${a.id_warehouse}` === `${selectedRow?.id_provider}${selectedRow?.id_warehouse}`) {
                    return {...selectedRow, edited: original != selectedRow?.[selectedCell]? true : false}
                }
                return a
            })
            
            herbaceo_table.filter((et:any) => 'edited' in et && et.edited).length > 0? setChangesFlag(false) : setChangesFlag(true)
            
            setData({...fullData,herbaceo:{...fullData.herbaceo,herbaceo_proveedores_table:herbaceo_table}})
            
            setComment("")
            handleClose()
        } else {
            let original = dataTableMASTER.find((ori:any) => `${ori.id}${ori.id_warehouse}` === `${selectedRow.id}${selectedRow.id_warehouse}`)?.[selectedCell]
            let aux = dataTable
    
            let herbaceo_table = aux.map((a:any) => {
                if(`${a.id}${a.id_warehouse}` === `${selectedRow?.id}${selectedRow?.id_warehouse}`) {
                    return {...selectedRow, edited: original != selectedRow?.[selectedCell]? true : false}
                }
                return a
            })
            
            herbaceo_table.filter((et:any) => 'edited' in et && et.edited).length > 0? setChangesFlag(false) : setChangesFlag(true)
            
            setData({...fullData,herbaceo:{...fullData.herbaceo,herbaceo_propio_table:herbaceo_table}})
            setComment("")
            handleClose()
        }
        

    }

    const renderLabel = () => {
        let field_array = selectedCell?.split("_")
        
        if(field_array?.length > 1) field_array?.pop() 
        
        let header_title = field_array?.map((word:string,index:number) => {
            if(index === 0) {
                return word.charAt(0).toUpperCase() + word.slice(1)
            }
            return word
        }).join(' ')

        return header_title === 'Crop'? 'Cultivo' : header_title === 'Comments'? 'Observaciones' : 'Format'
    }

    const header = () => {
        return (
            <span>Ajuste de parámetros</span>
        )
    }

    const footer = () => {
        return (
            <div className="scenarios-footer">
                <Button disabled={ comentarioEnEdicion !== undefined} severity={'success'} label="Actualizar" icon={<MdEdit style={{fontSize:20}} />}  onClick={handleUpdateDataHerbaceo} outlined  />
                <Button disabled={ comentarioEnEdicion !== undefined} severity={'danger'} label="Cancelar" icon={<MdOutlineCancel style={{fontSize:20,marginRight:5}} />}  outlined onClick={handleClose} />
            </div>
        )
    }

    const handleChangeValue = (e:any) => {
        const { value } = e.target
        setSelectedRow({...selectedRow,[selectedCell]:value.code})
        
    }

    const handleChangeValueComment = (e:any) => {
        const { value } = e.target
        setComment(value)
        setSelectedRow({...selectedRow,[selectedCell]:value})
        
    }


    const options = [
        {
            name: '700 mm',
            code: '700 mm'
        },
        {
            name: '900 mm',
            code: '900 mm'
        },
        {
            name: '700 mm / 900 mm',
            code: '700 mm / 900 mm'
        }
    ]

    const options_crop = [
        {
            name: "EMPTY",
            code: ""
        },
        {
            name: 'PAJA CEREAL',
            code:  'PAJA CEREAL',
        },
        {
            name: 'MAIZ',
            code:  'MAIZ',
        },
        {
            name: 'COLZA',
            code:  'COLZA',
        },
        {
            name: 'GIRASOL',
            code:  'GIRASOL',
        },
        {
            name: 'OTROS',
            code:  'OTROS',
        }
    ]


    return (
        <div className="card flex justify-content-center">
            <Dialog className={"edit-modal-dialog-base"} header={header} visible={visible} style={{ width: '35vw',height:'40vh' }} footer={footer} onHide={handleClose}>
                <div style={{minHeight:85,display:'flex',justifyContent:'center',alignItems:'center',padding:'1rem'}}>
                    <div className="card flex justify-content-center" style={{width:'95%'}}>
                        <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor={"error-name"}>{renderLabel()}</label>
                        {
                            renderLabel() === "Cultivo"?
                            <div className="permisos__header-input">
                                <Dropdown id={"error-name"} style={{width:'100%'}}  className="scenario-inputs" onChange={handleChangeValue} value={{name:selectedRow?.[selectedCell],code:selectedRow?.[selectedCell]}} options={options_crop} optionLabel="name"    />

                                <span className="p-inputgroup-addon" >
                                    <HiOutlinePencilSquare style={{fontSize:20}} />
                                </span>
                            </div>
                            :
                            renderLabel() === 'Format'?
                            <div className="permisos__header-input">
                                <Dropdown id={"error-name"} style={{width:'100%'}}  className="scenario-inputs" onChange={handleChangeValue} value={{name:selectedRow?.[selectedCell],code:selectedRow?.[selectedCell]}} options={options} optionLabel="name"    />

                                <span className="p-inputgroup-addon" >
                                    <HiOutlinePencilSquare style={{fontSize:20}} />
                                </span>
                            </div>
                            :
                            <div className="permisos__header-input">
                                <InputText id={"error-name"} style={{width:'100%'}} itemType="alphanum"  className="scenario-inputs" onChange={handleChangeValueComment} value={selectedRow?.[selectedCell]}    />

                                <span className="p-inputgroup-addon" >
                                    <HiOutlinePencilSquare style={{fontSize:20}} />
                                </span>
                            </div>
                        }
                    </div>
                </div>
                
            </Dialog>
        </div>
    )
}